import { useEffect } from 'react';
import { navigate } from "@reach/router"

const SlatesQrTagsPage = () => {
  useEffect(() => {
    navigate('/');
  }, []);
  return null;
};

export default SlatesQrTagsPage;